import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import './AssistedBookingStatus.scss';

export default class AssistedBookingStatus extends Component {
  static propTypes = {
    bookingComponentStatuses: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        status: PropTypes.string.isRequired,
        supplier: PropTypes.string.isRequired,
        component: PropTypes.string.isRequired,
        changed: PropTypes.bool.isRequired,
      }),
    ),
  };

  render() {
    const { bookingComponentStatuses } = this.props;

    return (
      <div>
        <div className="assisted-booking-status__row assisted-booking-status__row--header">
          <div className="assisted-booking-status__row__component assisted-booking-status__row--header">Component</div>
          <div className="assisted-booking-status__row__supplier assisted-booking-status__row--header">Supplier</div>
          <div className="assisted-booking-status__row__status assisted-booking-status__row--header">Status</div>
        </div>
        { bookingComponentStatuses.map(componentStatus => (
          <div className="assisted-booking-status__row" key={`${componentStatus.get('component')}-${componentStatus.get('supplier')}`}>
            <div className="assisted-booking-status__row__component">{componentStatus.get('component')}</div>
            <div className="assisted-booking-status__row__supplier">{componentStatus.get('supplier')}</div>
            <div className="assisted-booking-status__row__status">{componentStatus.get('status')}</div>
          </div>
        ))}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AssistedBookingStatus/AssistedBookingStatus.jsx
 **/